<template>
<div class="chapter">
<div class="inner_page">
<h1 class="h1"><a id="ch00_fm03_title"></a><a id="page_iii"></a><strong>Working the Diaspora</strong></h1>
<p class="bsubtitleleft"><em>The Impact of African Labor on the Anglo-American World, 1650</em>–1850</p>
<p class="authorleft"><strong>Frederick C. Knight</strong></p>
<p class="images1"><img alt="image" src="images/pub.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch00_fm03_title.vue?75e8a0c2